<div class="row">
  <div class="col-md-12">
    <div class="card">
      <div class="card-header text-center">
        <h4>REPORTE DE PREVENTA</h4>
        <form
          action=""
          [formGroup]="buscarForm"
          (ngSubmit)="buscarExistencia()"
          class="form-horizontal form-material noprint"
          id="categoryform"
          novalidate
        >
          <button onclick="window.print();return false;">
            <i class="fa fa-print"></i>
          </button>
          <div class="form-row">
            <div class="col">
              <app-form-error-wrapper
                [control]="buscarForm.controls['producto']"
                [controlName]="'Producto'"
              >
                <label for="inputGroupSelect02">Producto</label>
                <ng-select
                  bindLabel="name"
                  placeholder="Selecionar Producto"
                  [searchable]="true"
                  (change)="getSelectedProduct($event)"
                  formControlName="producto"
                >
                  <ng-option>
                    Seleccionar todos
                  </ng-option>
                  <ng-option [value]="item" *ngFor="let item of products">
                    {{ item.nombre_producto }}
                  </ng-option>
                </ng-select>
              </app-form-error-wrapper>
            </div>
            <div class="col-xs-12 col-md-2 mt-4">
              <button
                class="btn btn-info btn-lg btn-block text-uppercase waves-effect waves-light"
                [disabled]="buscarForm.invalid || isLoading"
              >
                <app-button-loader
                  [isLoading]="isLoading"
                  [label]="'Buscar'"
                ></app-button-loader>
              </button>
            </div>
          </div>
        </form>
      </div>
      <div class="card-body">
        <table
          class="table table-bordered table-striped table-condensed  table-responsive-md"
        >
          <thead>
            <tr>
              <th>#</th>
              <th>Nombre</th>
              <th>U.M</th>
              <th *hasPermission="['administrador', 'almacen']">Pedidos</th>
              <th *hasPermission="['administrador', 'almacen']">Stock</th>
              <th>P-S</th>
            </tr>
          </thead>
          <tbody *ngFor="let data of existencia; let i = index">
            <tr>
              <th scope="row">{{ i + 1 }}</th>
              <td>
                {{ data.nombre }}
              </td>
              <ng-template #statusAmarillo>
                <td>
                  {{ data.nombre }}
                </td>
              </ng-template>
              <ng-template #statusRojo>
                <td class="table-danger">{{ data.nombre }}</td>
              </ng-template>
              <td>{{ data.unidad }}</td>
              <td *hasPermission="['administrador', 'almacen']">
                {{ data.pedido }}
              </td>
              <td *hasPermission="['administrador', 'almacen']">
                {{ data.stock }}
              </td>
              <td>{{ data.diferencia }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
